import type { ItemLinkValue, ItemMultiLinkValue } from '@/common/api/types/items';
import type { FieldType } from './types';

const isLinkValue = (val: unknown): val is ItemLinkValue =>
  val !== null && typeof val === 'object' && 'LINK' in val;

const isMultiLinkItem = (item: unknown): item is ItemMultiLinkValue =>
  item !== null && typeof item === 'object' && 'MULTI_LINK' in item;

const toLinkApiValue = (val: ItemLinkValue | ItemMultiLinkValue) => {
  const url = 'LINK' in val ? val.LINK : val.MULTI_LINK;
  return { url, description: val.description };
};

export const toApiFieldValue = (fieldType: FieldType, value: unknown): unknown => {
  if (fieldType === 'LINK' && isLinkValue(value)) {
    return toLinkApiValue(value);
  }

  if (fieldType === 'MULTI_LINK' && Array.isArray(value)) {
    return value.map((item) => (isMultiLinkItem(item) ? toLinkApiValue(item) : item));
  }

  return value;
};
